import { useEffect, useState } from "react";
import axios from "axios";
import { MousePointerClick, Users } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Stats() {
  const [data, setData] = useState(null);
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/track/stats`).then((res) => setData(res.data)).catch(() => setData({ sections: [], total: 0 }));
    axios.get(`${API}/api/leads`).then((res) => setLeads(res.data)).catch(() => setLeads({ leads: [], total: 0 }));
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0E11] px-6 py-20 text-white">
      <div className="mx-auto max-w-4xl">
        <div className="flex items-center gap-3">
          <MousePointerClick className="h-6 w-6 text-[#EAB308]" />
          <h1 data-testid="stats-title" className="text-3xl font-extrabold">GTA Dashboard</h1>
        </div>
        <p className="mt-2 text-sm text-gray-500">CTA clicks & member applications — GTA landing page</p>

        {!data ? (
          <p className="mt-10 text-gray-400">Loading…</p>
        ) : (
          <>
            <div data-testid="stats-total" className="mt-10 rounded-2xl border border-[#EAB308]/30 bg-[#0C1732] p-6">
              <p className="font-mono-num text-4xl font-bold text-[#EAB308]">{data.total}</p>
              <p className="mt-1 text-sm text-gray-400">Total CTA clicks</p>
            </div>
            <div className="mt-6 overflow-hidden rounded-2xl border border-white/10">
              {data.sections.length === 0 ? (
                <p className="p-6 text-sm text-gray-500">No clicks recorded yet.</p>
              ) : (
                data.sections.map((s) => (
                  <div
                    key={s.section}
                    data-testid={`stats-row-${s.section}`}
                    className="flex items-center justify-between border-b border-white/5 bg-[#0C1732] px-6 py-4 last:border-0"
                  >
                    <span className="font-mono-num text-sm uppercase tracking-wider text-gray-300">{s.section}</span>
                    <span className="font-mono-num text-lg font-bold text-white">{s.count}</span>
                  </div>
                ))
              )}
            </div>
          </>
        )}

        <div className="mt-14 flex items-center gap-3">
          <Users className="h-6 w-6 text-[#EAB308]" />
          <h2 className="text-2xl font-extrabold">Member Applications</h2>
          {leads && <span className="rounded-full bg-[#EAB308]/15 px-3 py-1 font-mono-num text-sm font-bold text-[#EAB308]">{leads.total}</span>}
        </div>

        {!leads ? (
          <p className="mt-6 text-gray-400">Loading…</p>
        ) : leads.leads.length === 0 ? (
          <p className="mt-6 rounded-2xl border border-white/10 bg-[#0C1732] p-6 text-sm text-gray-500">No applications yet.</p>
        ) : (
          <div className="mt-6 space-y-4">
            {leads.leads.map((l, i) => (
              <div key={l.id || i} data-testid={`lead-row-${i}`} className="rounded-2xl border border-white/10 bg-[#0C1732] p-5">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="text-base font-bold text-white">{l.name}</span>
                  <span className="font-mono-num text-xs text-gray-500">{(l.created_at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
                <div className="mt-3 flex flex-wrap gap-2 text-xs">
                  {[l.country, l.experience, l.capital, l.market, l.lang].filter(Boolean).map((v, j) => (
                    <span key={j} className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-gray-300">{v}</span>
                  ))}
                </div>
                <div className="mt-3 space-y-0.5 text-sm text-gray-400">
                  {l.broker && <p>Broker: <span className="text-gray-200">{l.broker}</span></p>}
                  {l.telegram && <p>Telegram: <span className="text-gray-200">{l.telegram}</span></p>}
                  {l.contact && <p>Contact: <span className="text-gray-200">{l.contact}</span></p>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
